// ثوابت ومساعدات منصة مسار (واجهة)
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

export const LEVEL_AR = { B: "مبتدئ", I: "متوسط", A: "متقدم", E: "خبير" };
export const LEVELS = ["B", "I", "A", "E"];
export const LEVEL_TONE = { B: "muted", I: "sky", A: "emerald", E: "gold" };
export const TYPE_AR = { leadership: "قيادية", behavioral: "سلوكية", technical: "فنية" };
export const TYPE_TONE = { leadership: "gold", behavioral: "sky", technical: "emerald" };
export const STATUS_AR = { required: "مطلوبة في المسار", completed: "اكتمل التدريب", met: "مستوفاة", gap: "تحتاج تطويرًا", needs_assessment: "بحاجة إلى تقييم", needs_review: "بحاجة إلى مراجعة" };
export const STATUS_TONE = { required: "gold", completed: "emerald", met: "emerald", gap: "red", needs_assessment: "gold", needs_review: "muted" };
export const GAP_AR = { training_completed: "اكتمل التدريب", open: "متطلب قيد الإكمال", closed: "مغلقة", waiting_program: "بانتظار توفير برنامج مناسب", needs_assessment: "بحاجة إلى تقييم" };
export const STEP_AR = { pending: "لم تبدأ", in_progress: "قيد التنفيذ", completed: "منجزة" };
export const CERT_TONE = { draft: "muted", submitted: "gold", needs_info: "gold", approved: "emerald", rejected: "red", expired: "red", revoked: "red" };
export const PROGRAM_TONE = { draft: "muted", ready_for_review: "gold", published: "emerald", suspended: "red", archived: "muted" };
export const NA_TEXT = "لم تُنشر دورات في هذا النطاق بعد";

export const lv = (code) => (code ? `${code} — ${LEVEL_AR[code] || ""}` : "—");
export const fmtDate = (s) => (s ? String(s).slice(0, 10) : "—");
export const fmtNum = (n) => (n == null || n === "" ? "—" : Number(n).toLocaleString("en-US"));
export const fmtInd = (i) => {
  if (!i) return "—";
  if (i.status === "na") return "غير متاح";
  if (i.status === "nc" || i.value == null) return "—";
  return i.unit === "%" ? `${i.value}%` : fmtNum(i.value);
};
export const tamayozHome = (user) => "/dashboard";

export const useMasarMe = () => useQuery({ queryKey: ["masar-me"], queryFn: async () => (await api.get("/masar/me")).data });
export const useJourney = () => useQuery({ queryKey: ["masar-journey"], queryFn: async () => (await api.get("/masar/journey")).data });
export const KIND_AR = { professional: "شهادة احترافية", academic: "مؤهل تعليمي", internal: "شهادة إتمام برنامج", course: "شهادة دورة" };
export const PROGRAM_STATE_TONE = { completed: "emerald", in_progress: "gold", not_started: "muted", unavailable: "muted" };
export const JOIN_AR = { request: "طلب انضمام", link: "التسجيل عند المزود", none: "" };
export const useMasarAccess = (enabled = true) =>
  useQuery({ queryKey: ["masar-access"], queryFn: async () => (await api.get("/masar/access")).data, enabled, staleTime: 60_000 });
export const useLookups = () =>
  useQuery({ queryKey: ["masar-lookups"], queryFn: async () => (await api.get("/masar/admin/lookups")).data, staleTime: 60_000 });
export const useDashboard = (params = {}) =>
  useQuery({ queryKey: ["masar-dashboard", params], queryFn: async () => (await api.get("/masar/admin/dashboard", { params })).data, retry: 1 });
export const useReportOptions = () =>
  useQuery({ queryKey: ["masar-report-options"], queryFn: async () => (await api.get("/masar/admin/reports/options")).data, staleTime: 120_000 });
